import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { UserCompanyType, UserRole } from '@leedpulse-monorepo/enums';

export interface UpdateCompanyUsersEntry {
  uid: string;
  role: UserCompanyType;
}

interface UpdateCompanyUsersPayload {
  company_id: string;
  users: UpdateCompanyUsersEntry[];
}

interface UpdateCompanyUsersResponse {
  company_id: string;
  applied: string[];
  removed: string[];
  total: number;
  message?: string;
}

async function updateCompanyUsers(
  payload: UpdateCompanyUsersPayload,
  auth: Authentication | null
): Promise<UpdateCompanyUsersResponse> {
  if (!auth) {
    throw new UpdateCompanyUsersFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');
  }

  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdateCompanyUsersFailure('Unauthorized', 'unauthorized');
  }

  if (!payload.company_id?.trim()) {
    throw new UpdateCompanyUsersFailure('company_id is required');
  }

  if (!Array.isArray(payload.users)) {
    throw new UpdateCompanyUsersFailure('users must be an array');
  }

  try {
    const response = await HttpClient.post(
      '/backoffice/companies/users/update',
      payload,
      auth.token
    );
    return (response?.data ?? response) as UpdateCompanyUsersResponse;
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Unknown error';
    throw new UpdateCompanyUsersFailure(message);
  }
}

export class UpdateCompanyUsersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateCompanyUsers;
